import * as React from "react"
import type { SVGProps } from "react"
const SvgLongArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M13 16.3V5.14a1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.29 1 1 0 0 0-.71.29 1 1 0 0 0-.29.71V16.3l-2.85-2.85a1 1 0 0 0-.7-.3q-.4.02-.7.3-.3.3-.31.7a1 1 0 0 0 .29.72l4.57 4.58q.14.15.32.21a1 1 0 0 0 .75 0 1 1 0 0 0 .33-.21l4.57-4.58q.3-.3.29-.71a1 1 0 0 0-1.01-1 1 1 0 0 0-.7.29z" />
  </svg>
)
export default SvgLongArrowDown
